import { request } from '@/common/appCtx';
export const baseURL = __BASEURL__ || window.location.origin;

const api = {
  exportHistoryList(params: any) {
    return request.get('/api/wfm/admin/attendance/clock/archive_data/export_history_list', { params });
  },
};

export default api;
